import { get, post } from '@/utils/request'

const accountApi = {
  accountAuth: '/api/auth',
  accountCode: '/api/auth/code',
  accountUpdate: '/api/account/update',
  accountSession: '/api/account/session',
  getRegistryStatusApi: '/api/auth/registry',
  apiKeyApi: '/api/account/apikey',
  userVip: '/api/user/vip',
  updateAvatarApi: '/api/file/avatar/update',
  accountMy: '/api/account/my',
  accountUser: '/api/account/user'
}

export function register(userRegistry) {
  return post(accountApi.accountAuth + '/create', userRegistry)
}

export function forgot(userRegistry) {
  return post(accountApi.accountAuth + '/forgot', userRegistry)
}

export function resetPassword(resetPasswordData) {
  return post(accountApi.accountUpdate + '/password', resetPasswordData)
}

export function updateScreenName(jsonData) {
  return post(accountApi.accountMy + '/screen_name', jsonData)
}

// 获取公钥
export function getPubkey(channel) {
  return get(accountApi.accountCode + '/pubkey?channel=' + channel)
}

// 获取图形验证码
export function getCaptchaCode() {
  return get(accountApi.accountCode + '/captcha')
}

// 获取短信验证码
export function getVerifyCode(verifyCode) {
  return post(accountApi.accountCode + '/verify', verifyCode)
}

// 登入
export function login(loginData) {
  return post(accountApi.accountAuth + '/signin', loginData)
}

// 登出
export function logout() {
  return get(accountApi.accountAuth + '/signout')
}

// 刷新 token
export function refreshToken() {
  return post(accountApi.accountAuth + '/refresh_token')
}

// 获取注册开放状态
export function getRegistryStatus() {
  return get(accountApi.getRegistryStatusApi)
}

export function getSessionList() {
  return get(accountApi.accountSession + '/list')
}

export function logoutSession(jsonData) {
  return post(accountApi.accountSession + '/signout', jsonData)
}

// 1. 获取当前用户的所有 API Key 列表
export function getApiKeyList() {
  return get(accountApi.apiKeyApi + '/list')
}

// 2. 创建新的 API Key
export function createApiKey(jsonData) {
  return post(accountApi.apiKeyApi + '/list', jsonData)
}

// 3. 禁用 API Key
export function disableApiKey(ak) {
  return post(accountApi.apiKeyApi + '/disable', { ak: ak })
}

export function updateAvatar(userAvatar) {
  return post(accountApi.updateAvatarApi, userAvatar)
}

// VIP
export function getMyVip() {
  return get(accountApi.userVip + '/my')
}

export function getVipPlans() {
  return get(accountApi.userVip + '/plan')
}

export function buyVip(data) {
  return post(accountApi.userVip + '/buy', data)
}

export function addResume(payload) {
  return post(accountApi.accountUser + '/resume', payload)
}

export function getResume() {
  return get(accountApi.accountUser + '/resume')
}
